const ITEMS = [
  "ALBA IULIA",
  "ART & OUTDOOR ROMÂNIA",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-6 font-display text-2xl font-black uppercase tracking-tight sm:text-4xl ${
            i % 2 === 0 ? "text-white/90" : "text-outline-neon"
          }`}
        >
          {item}
        </span>
        <span className="text-xl text-flame sm:text-2xl">✦</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="kinetic-marquee"
    className="overflow-hidden border-y border-white/10 bg-surface py-6"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
